import { useEffect, useState } from 'react';
import { plugin, debug } from 'light-component';
import * as Base from '@base';
import { Require } from '../component';
import { useTranslation } from '../../i18n';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { FormBlock, FormBlockTree, FormTreeSelectProps } from './types';

export function WidgetFormTreeSelect(props: FormTreeSelectProps): ReactElement {
  debug.widget('dashboard FormTreeSelect', props);
  const [t] = useTranslation();
  const [options, setOptions] = useState<FormBlockTree[]>([]);
  const [titles, setTitles] = useState<FormBlock[]>([]);
  const [values, setValues] = useState<string[]>([]);

  const onChange = (ids: string[]): void => {
    const changeValues = ids.length > 0 ? ids : [];
    setValues(changeValues);
    const value = titles.filter(item => {
      for (const changeValue of changeValues) {
        if (item.name === changeValue || item.path.includes(changeValue)) {
          return true;
        }
      }
      return false;
    });
    props.onChange?.(value.map(item => item.name));
  };

  useEffect(() => {
    // ShotEyesBlock 分组 ShotEyesSubBlock 分类
    // 不等于ShotEyesSubBlock ShotEyesBlock Input TextArea 题目
    const blocks = props.options?.filter(item => item.type === 'ShotEyesBlock') ?? [];
    const suBlocks = props.options?.filter(item => item.type === 'ShotEyesSubBlock') ?? [];
    const titles = props.options?.filter(item => item.type !== 'ShotEyesSubBlock'
      && item.type !== 'ShotEyesBlock'
      && item.type !== 'Input'
      && item.type !== 'TextArea') ?? [];

    const tree: FormBlockTree[] = [];
    for (const block of blocks) {
      const item: FormBlockTree = {
        title: block.description,
        value: block.name,
        key: block.name,
        children: []
      };
      for (const suBlock of suBlocks) {
        if (suBlock.path.includes(block.name)) {
          const subItem: FormBlockTree = {
            title: suBlock.description,
            value: suBlock.name,
            key: suBlock.name,
            children: []
          };
          for (const title of titles) {
            if (title.path.includes(block.name)) {
              subItem.children.push({
                title: title.description,
                value: title.name,
                key: title.name,
                children: []
              });
            }
          }
          item.children.push(subItem);
        }
      }


      // 说明没有分类
      if (item.children.length === 0) {
        for (const title of titles) {
          if (title.path.includes(block.name)) {
            item.children.push({
              title: title.description,
              value: title.name,
              key: title.name,
              children: []
            });
          }
        }
      }
      tree.push(item);
    }

    // 没有分组
    if (tree.length === 0) {
      for (const suBlock of suBlocks) {
        const subItem: FormBlockTree = {
          title: suBlock.description,
          value: suBlock.name,
          key: suBlock.name,
          children: []
        };
        for (const title of titles) {
          if (title.path.includes(suBlock.name)) {
            subItem.children.push({
              title: title.description,
              value: title.name,
              key: title.name,
              children: []
            });
          }
        }
        tree.push(subItem);
      }
    }

    // 没有分组/分类
    if (tree.length === 0) {
      for (const title of titles) {
        const subItem: FormBlockTree = {
          title: title.description,
          value: title.name,
          key: title.name,
          children: []
        };
        tree.push(subItem);
      }
    }

    setTitles(titles);
    setOptions(tree);
  }, [props.options]);

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Base.TreeSelect
        className={styles.treeSelect}
        treeIcon
        value={values}
        placeholder={t('请选择')}
        showSearch
        allowClear
        autoClearSearchValue
        size='middle'
        showCheckedStrategy={Base.TreeSelect.SHOW_PARENT}
        treeCheckable
        treeNodeFilterProp='title'
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={options}
        onChange={onChange}
        multiple
        maxTagCount={3}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'form-tree', component: WidgetFormTreeSelect });
